import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { Link, useLocation, useParams } from "react-router-dom";
import { isEmpty, map } from "lodash";
import moment from "moment";
import {
  Button,
  Card,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Nav,
  NavItem,
  NavLink,
  Spinner,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import classnames from "classnames";

//Import Scrollbar
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import images from "assets/images";
import {
  addMessage as onAddMessage,
  getChats as onGetChats,
  getContacts as onGetContacts,
  getGroups as onGetGroups,
  getMessages as onGetMessages,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import ChatProfileCard from "components/Chat/ChatProfileCard";
import { useLocalStorage } from "hooks/userLocalStorage";
import useMessagePolling from "hooks/useChatPolling";
import UserAvatarFromName from "components/Common/UserAvatarFromName";
import CenterModal from "components/Common/CenterModal";
import InviteForm from "components/ParentingSpace/InviteMemberForm";
import { getChats, getMessages, sendModeratorMessageApi } from "helpers/fakebackend_helper";
import { useQuery, useMutation } from "react-query";

const Chat = props => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: parentingSpaceId } = useParams();

  const { chats, groups, contacts, messages, loading } = useSelector(state => ({
    chats: state.chat.chats,
    groups: state.chat.groups,
    contacts: state.chat.contacts,
    messages: state.chat.messages,
    loading: state.chat.loading,
  }));

  // Helper function to create room ID with lower ID first
  const createRoomId = (id1, id2) => {
    const lowerId = Math.min(id1, id2);
    const higherId = Math.max(id1, id2);
    return `individual_${lowerId}_${higherId}`;
  };

  // Helper function to normalize an existing room ID (in case it comes in wrong format)
  const normalizeRoomId = (roomId) => {
    if (!roomId || !roomId.startsWith('individual_')) {
      return roomId;
    }
    const parts = roomId.replace('individual_', '').split('_');
    if (parts.length === 2) {
      const id1 = parseInt(parts[0], 10);
      const id2 = parseInt(parts[1], 10);
      if (!isNaN(id1) && !isNaN(id2)) {
        return createRoomId(id1, id2);
      }
    }
    return roomId;
  };

  // Move the query definition up before any effects that use it
  const { data: chatRoom, isLoading: isChatRoomLoading } = useQuery(
    'chat_contacts', 
    getChats, 
    {
      refetchOnWindowFocus: false,
    }
  );

  const [messageBox, setMessageBox] = useState(null);
  const [currentRoomId, setCurrentRoomId] = useState(1);
  const [currentUser, setCurrentUser] = useState({
    name: "Henry Wells",
    isActive: true,
  });

  const { getAuthUserID, getAuthUserName } = useLocalStorage();
  const authUserID = getAuthUserID();
  const authUserName = getAuthUserName();

  // useMessagePolling();
  const [menu1, setMenu1] = useState(false);
  const [search_Menu, setsearch_Menu] = useState(false);
  const [settings_Menu, setsettings_Menu] = useState(false);
  const [other_Menu, setother_Menu] = useState(false);
  const [activeTab, setactiveTab] = useState("1");
  const [Chat_Box_Username, setChat_Box_Username] = useState("");
  const [Chat_Box_User_Status, setChat_Box_User_Status] = useState("");
  const [curMessage, setcurMessage] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  const [messagesData, setMessagesData] = useState([]);

  useEffect(() => {
    console.log("Chat component is now rendering!");
  }, []);

  useEffect(() => {
    console.log("curMessage", curMessage);
  }, [curMessage]);
  
  // Define the mutation for fetching messages
  const { mutate: fetchMessages } = useMutation(
    (channelId) => getMessages(channelId),
    {
      onSuccess: (data) => {
        setMessagesData(data);
        console.log("Messages data structure:", data);
        console.log("Individual messages:", data.messages);
        scrollToBottom();
      },
      onError: (error) => {
        console.error("Error fetching messages:", error);
      },
    }
  );

  // Handle room_id from query parameters
  useEffect(() => {
    if (!chatRoom || isChatRoomLoading) return;

    const urlParams = new URLSearchParams(location.search);
    const roomIdFromQuery = urlParams.get('room_id');
    
    if (roomIdFromQuery) {
      // Normalize the room ID to ensure lower ID comes first
      const normalizedRoomId = normalizeRoomId(roomIdFromQuery);
      console.log("Room ID from query:", roomIdFromQuery, "Normalized:", normalizedRoomId);
      setCurrentRoomId(normalizedRoomId);
      fetchMessages(normalizedRoomId);
      
      // Find the chat room to set the username
      const currentChat = chatRoom.contacts.find(chat => {
        const { user1, user2 } = chat;
        return createRoomId(user1.id, user2.id) === normalizedRoomId;
      });
      
      if (currentChat) {
        const { user1, user2 } = currentChat;
        setChat_Box_Username(`${user1.name} & ${user2.name}`);
      }
    }
  }, [location.search, chatRoom, isChatRoomLoading, fetchMessages]);

  // Ensure scroll to bottom when messages change
  useEffect(() => {
    if (messagesData?.messages?.length > 0) {
      scrollToBottom();
    }
  }, [messagesData]);

  // Ensure scroll to bottom when messageBox ref is set
  useEffect(() => {
    if (messageBox && messagesData?.messages?.length > 0) {
      scrollToBottom();
    }
  }, [messageBox]);

  useEffect(() => {
    // dispatch(onGetChats());
    dispatch(onGetGroups());
    dispatch(onGetContacts());
    dispatch(onGetMessages(currentRoomId));
  }, [onGetChats, onGetGroups, onGetContacts, onGetMessages, currentRoomId]);

  useEffect(() => {
    dispatch(onGetChats());
  }, []);

  useEffect(() => {
    if (chats.length > 0 && !location.search.includes('room_id')) {
      console.log('chats[0].roomId', chats[0].roomId);
      setCurrentRoomId(chats[0].roomId);
    }
  }, [chats, location.search]);

  // useEffect(() => {
  //   if (chats.length > 0) {
  //     setChat_Box_Username(chats[0].name);  
  //     setChat_Box_User_Status(chats[0].status);  
  //     setCurrentRoomId(chats[0].roomId);  
  //     dispatch(onGetMessages(chats[0].roomId));
  //   } else {
  //     setChat_Box_Username("Live invite user to space to start conversation"); 
  //     setChat_Box_User_Status("offline"); 
  //   }
  // }, [chats]);

  useEffect(() => {
    const currentChat = chats.find(chat => chat.roomId === currentRoomId);
    if (currentChat) {
      setChat_Box_Username(currentChat.name);
      setChat_Box_User_Status(currentChat.status);
    }
  }, [currentRoomId, chats]);
 

  useEffect(() => {
    if (!isEmpty(messages)) scrollToBottom();
  }, [messages]);

  // const toggleNotification = () => {
  //   setnotification_Menu(!notification_Menu)
  // }

  //Toggle Chat Box Menus
  const toggleSearch = () => {
    setsearch_Menu(!search_Menu);
  };

  const toggleSettings = () => {
    setsettings_Menu(!settings_Menu);
  };

  const toggleOther = () => {
    setother_Menu(!other_Menu);
  };

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  //moderator message 
  const { mutate: sendModeratorMessage } = useMutation(
    (channelId, message) => sendModeratorMessageApi({room_id:channelId, message:curMessage}),
    {
      onSuccess: (data) => {
        console.log("Moderator message sent successfully:", data);
        //refetch messages
        fetchMessages(currentRoomId);
        //clear message box
        setcurMessage("");
      },
      onError: (error) => {
        console.error("Error sending moderator message:", error);
      },
    }
  );
  

  //Use For Chat Box
  const userChatOpen = (id, name, status, roomId) => {
    setChat_Box_Username(name);
    setCurrentRoomId(roomId);
    fetchMessages(roomId);
  };

  const addMessage = (roomId, sender) => {
    const receiverID = chats.find(chat => chat.roomId === roomId).id;
    if(!receiverID) {
      console.log("receiverID not found");
      return;
    }

    
    const message = {
      id: Math.floor(Math.random() * 100),
      roomId,
      sender,
      receiver_id: receiverID,
      message: curMessage,
      createdAt: new Date(),
    };
    setcurMessage("");
    dispatch(onAddMessage(message));
  };

  const scrollToBottom = () => {
    if (messageBox) {
      setTimeout(() => {
        messageBox.scrollTop = messageBox.scrollHeight + 1000;
      }, 100); // Small delay to ensure content is rendered
    }
  };

  const onKeyPress = e => {
    const { key, value } = e;
    if (key === "Enter") {
      setcurMessage(value);
      addMessage(currentRoomId, currentUser.name);
    }
  };

  //serach recent user
  const searchUsers = () => {
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById("search-user");
    filter = input.value.toUpperCase();
    ul = document.getElementById("recent-list");
    li = ul.getElementsByTagName("li");
    for (i = 0; i < li.length; i++) {
      a = li[i].getElementsByTagName("a")[0];
      txtValue = a.textContent || a.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        li[i].style.display = "";
      } else {
        li[i].style.display = "none";
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          {/* <title>Chat </title> */}
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Parent" breadcrumbItem="Member Messages" />

          <Row>
            <Col lg="12">
              <div className="d-lg-flex">
                <div className="chat-leftsidebar me-lg-4">
                  <div className="">

                     {/* <ChatProfileCard/> */}

                  

                    <div className="chat-leftsidebar-nav">
                           
                      <TabContent activeTab={activeTab} className="py-4">
                        <TabPane tabId="1">
                          <div>
                            <h5 className="font-size-14 mb-3">Member Messaging</h5>
                            <ul className="list-unstyled chat-list" id="recent-list">
                              <PerfectScrollbar 
                              // style={{ height: "410px" }}
                              >
                                {loading?.chatsloading ? (
                                  <div className="text-center">
                                    <Spinner animation="border" role="status">
                                      <span className="sr-only">Loading...</span>
                                    </Spinner>
                                  </div>
                                ) : (
                                  
                                  chatRoom && chatRoom?.contacts?.length > 0 ? (
                                    map(chatRoom?.contacts, chat => {
                                      const { user1, user2 } = chat;
                                      return (
                                        <li
                                          key={user1.id + user2.id}
                                          className={
                                            currentRoomId === createRoomId(user1.id, user2.id)
                                              ? "active"
                                              : ""
                                          }
                                        >
                                          <Link
                                            to="#"
                                            onClick={() => {
                                              userChatOpen(
                                                user1.id,
                                                user1.name,
                                                user1.status,
                                                createRoomId(user1.id, user2.id)
                                              );
                                            }}
                                          >
                                            <div className="d-flex">
                                              <div className="align-self-center me-3">
                                                <UserAvatarFromName name={user1.name} size="sm" />
                                              </div>
                                              <div className="align-self-center me-3">
                                                <UserAvatarFromName name={user2.name} size="sm" />
                                              </div>
                                              <div className="flex-grow-1 overflow-hidden">
                                                <h5 className="text-truncate font-size-14 mb-1">
                                                  {user1.name} & {user2.name}
                                                </h5>
                                                <p className="text-truncate mb-0">
                                                  {chat.description}
                                                </p>
                                              </div>
                                              <div className="font-size-11">
                                                {chat.time}
                                              </div>
                                            </div>
                                          </Link>
                                        </li>
                                      );
                                    })
                                  ) : (
                                    <div className="text-center">
                                      {/* <p>No conversations yet. Start a new conversation!</p>
                                      <Button color="primary" onClick={toggleModal}>Invite User</Button>
                                      <CenterModal isOpen={modalOpen}
                                        toggle={toggleModal}
                                        title="Invite User">
                                            <InviteForm  setModal={setModalOpen}/>
                                        </CenterModal> */}
                                    </div>
                                  )
                                )}
                              </PerfectScrollbar>
                            </ul>
                          </div>
                        </TabPane>

                        <TabPane tabId="2">
                          <h5 className="font-size-14 mb-3">Group</h5>
                          <ul className="list-unstyled chat-list">
                            <PerfectScrollbar style={{ height: "410px" }}>
                              {groups &&
                                groups.map(group => (
                                  <li key={"test" + group.image}>
                                    <Link
                                      to="#"
                                      onClick={() => {
                                        userChatOpen(
                                          group.id,
                                          group.name,
                                          group.status,
                                          Math.floor(Math.random() * 100)
                                        );
                                      }}
                                    >
                                      <div className="d-flex align-items-center">
                                        <div className="avatar-xs me-3">
                                          <span className="avatar-title rounded-circle bg-primary bg-soft text-primary">
                                            {group.image}
                                          </span>
                                        </div>

                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14 mb-0">
                                            {group.name}
                                          </h5>
                                        </div>
                                      </div>
                                    </Link>
                                  </li>
                                ))}
                            </PerfectScrollbar>
                          </ul>
                        </TabPane>

                        <TabPane tabId="3">
                          <h5 className="font-size-14 mb-3">Contact</h5>

                          <div>
                            <PerfectScrollbar style={{ height: "410px" }}>
                              {contacts &&
                                contacts.map(contact => (
                                  <div key={"test_" + contact.id}>
                                    <ul className="list-unstyled chat-list">
                                      <li key={"test" + contact.id}>
                                        <Link
                                          to="#"
                                          onClick={() => {
                                            userChatOpen(
                                              contact.id,
                                              contact.name,
                                              contact.status,
                                              Math.floor(Math.random() * 100)
                                            );
                                          }}
                                        >
                                          <h5 className="font-size-14 mb-0">
                                            {contact.name}
                                          </h5>
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                ))}
                            </PerfectScrollbar>
                          </div>
                        </TabPane>
                      </TabContent>
                    </div>
                  </div>
                </div>
                <div className="w-100 user-chat">
                  <Card>
                    <div className="p-4 border-bottom ">
                      <Row>
                        <Col md="4" xs="9">
                          <h5 className="font-size-15 mb-1">
                            {Chat_Box_Username}
                          </h5>

                          <p className="text-muted mb-0">
                            {/* <i
                              className={
                                Chat_Box_User_Status === "online"
                                  ? "mdi mdi-circle text-success align-middle me-1"
                                  : Chat_Box_User_Status === "intermediate"
                                    ? "mdi mdi-circle text-warning align-middle me-1"
                                  : "mdi mdi-circle align-middle me-1"
                              }
                            /> */}
                            {Chat_Box_User_Status}
                          </p>
                        </Col>
                        <Col md="8" xs="3">
                          <ul className="list-inline user-chat-nav text-end mb-0">
                            <li className="list-inline-item d-none d-sm-inline-block">
                              <Dropdown
                                isOpen={search_Menu}
                                toggle={toggleSearch}
                              >
                                <DropdownToggle className="btn nav-btn" tag="i">
                                  <i className="bx bx-search-alt-2" />
                                </DropdownToggle>
                                <DropdownMenu
                                  className="dropdown-menu-md"
                                >
                                  <Form className="p-3">
                                    <FormGroup className="m-0">
                                      <InputGroup>
                                        <Input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search ..."
                                          aria-label="Recipient's username"
                                        />
                                        {/* <InputGroupAddon addonType="append"> */}
                                        <Button color="primary" type="submit">
                                          <i className="mdi mdi-magnify" />
                                        </Button>
                                        {/* </InputGroupAddon> */}
                                      </InputGroup>
                                    </FormGroup>
                                  </Form>
                                </DropdownMenu>
                              </Dropdown>
                            </li>
                            
                          </ul>
                        </Col>
                      </Row>
                    </div>
                    {/* messageing list box */}
                    
                    <div className={Chat_Box_Username ? "" : "d-none"}>
                      <div className="chat-conversation p-3">
                        <ul className="list-unstyled">
                          {loading?.getMessagesLoading ? (
                            <div className="d-flex justify-content-center align-items-center">
                              <Spinner animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                              </Spinner>
                            </div>
                          ) : (
                            <PerfectScrollbar
                              style={{ height: "470px" }}
                              containerRef={ref => setMessageBox(ref)}
                            >
                              <li>
                                <div className="chat-day-title">
                                  <span className="title">Today</span>
                                </div>
                              </li>
                              {messagesData &&
                                map(messagesData.messages, message => {
                                  const isSenderOnLeft = message.sender_id < message.receiver_id; // Determine position based on IDs
                                  const isModeratorMessage = message.message_type === "moderator";
                                  return (
                                    <li
                                      key={"test_k" + message.id}
                                      className={isSenderOnLeft ? "" : "right"} // Apply class based on position
                                    >
                                      <div className="conversation-list">
                                        <div 
                                          className={`ctext-wrap ${isModeratorMessage ? "bg-success bg-soft" : ""}`}
                                          style={{
                                            border: message.reported_by ? "2px solid #dc3545" : "none",
                                            borderRadius: message.reported_by ? "8px" : "none"
                                          }}
                                        >
                                          <div className="conversation-name">
                                            {isModeratorMessage && <i className="fas fa-shield-alt me-1" />}
                                            {isSenderOnLeft ? message.sender_name : message.sender_name}
                                            {isModeratorMessage && <span className="ms-2 badge bg-success">Moderator</span>}
                                            {message.reported_by && <span className="ms-2 badge bg-danger">Reported</span>}
                                          </div>
                                          <p>{message.message}</p>
                                          <div className="chat-time mb-0">
                                            {message.is_read ? <i className="fas fa-check-double align-middle" style={{ color: '#007FFF' }} /> : <i className="fas fa-check align-middle" style={{ color: 'grey' }} />}
                                            <span className="chat-time-text ml-2">{moment(message.created_at).format("DD-MM-YY HH:mm")}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  );
                                })}
                            </PerfectScrollbar>
                          )}
                        </ul>
                      </div>
                      <div className="p-3 chat-input-section">
                        <Row>
                          <Col>
                            <div className="position-relative">
                              <textarea
                                type="text"
                                value={curMessage}
                                onKeyPress={onKeyPress}
                                onChange={e => setcurMessage(e.target.value)}
                                className="form-control chat-input"
                                placeholder="Enter Message..."
                                rows={3}
                              />
                              <div className="chat-input-links">
                               
                              </div>
                            </div>
                            <Button
                              type="button"
                              color="primary"
                              style={{ backgroundColor: "#2F8C47" }}
                              onClick={() => {
                                console.log("currentRoomId", currentRoomId);
                                console.log("curMessage", curMessage);
                                sendModeratorMessage(currentRoomId, curMessage)
                              }}
                              className="btn btn-primary btn-rounded chat-send w-md mt-3"
                            >
                              <span className="d-none d-sm-inline-block me-2">
                                Send Message as Moderator
                              </span>{" "}
                                <i className="mdi mdi-send" />
                              </Button>
                          </Col>
                          <Col className="col-auto">
                            {/* {loading?.addMessageLoading ? (
                              <div className="d-flex justify-content-center align-items-center">
                                <Spinner animation="border" role="status">
                                  <span className="sr-only">Loading...</span>
                                </Spinner>
                              </div>
                            ) : (
                            <Button
                              type="button"
                              color="primary"
                              style={{ backgroundColor: "#2F8C47" }}
                              onClick={() => {
                                console.log("currentRoomId", currentRoomId);
                                console.log("curMessage", curMessage);
                                sendModeratorMessage(currentRoomId, curMessage)
                              }}
                              className="btn btn-primary btn-rounded chat-send w-md "
                            >
                              <span className="d-none d-sm-inline-block me-2">
                                Send Message as Moderator
                              </span>{" "}
                                <i className="mdi mdi-send" />
                              </Button>
                            )} */}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </Col>
          </Row>
          <div>
            
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

Chat.propTypes = {
  chats: PropTypes.array,
  groups: PropTypes.array,
  contacts: PropTypes.array,
  messages: PropTypes.array,
  onGetChats: PropTypes.func,
  onGetGroups: PropTypes.func,
  onGetContacts: PropTypes.func,
  onGetMessages: PropTypes.func,
  onAddMessage: PropTypes.func,
};

export default Chat;